export const isBrowserNotSupportedError = (error: unknown): boolean =>
  error instanceof Error && error.message === 'BrowserError';
